import { useInfiniteQuery } from 'react-query';

import { communityFeedApi } from 'src/Services/API';

const useFetchCommunityFeedItemLikes = (feedItemId: string) => {
  return useInfiniteQuery({
    queryKey: ['fetch-community-feed-item-likes', feedItemId],
    queryFn: async ({ pageParam = null }) => {
      return (await communityFeedApi.communityFeedControllerListLikes(feedItemId, 20, pageParam))
        .data;
    },
    getNextPageParam: lastPage => lastPage.endCursor ?? undefined,
  });
};

export default useFetchCommunityFeedItemLikes;
